exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "body span{vertical-align:inherit}.alex-map,.alex-map .alex-map-angular,.alex-map .map-container{height:100%}.alex-map .the-map:not(.is-fullscreen){height:700px;max-height:75vh}.alex-map .the-map .alert{margin:128px 30px 30px}.alex-map .the-map .al-control-container-top-center{min-width:260px}", ""]);

// exports
